// extracted by mini-css-extract-plugin
export default {"group":"EditorMenu_group__-lMp9","active":"EditorMenu_active__votpQ"};